import { take, call, put, fork, select,
  cancel
  // takeEvery
} from 'redux-saga/effects'

// import { history } from './../store'
import { sendPortfolio, sendResult } from '../api/messages'
import { fillZero } from './../helpers'

import { 
  ON_CHANGE_FORM,
  POST_FORM_REQUEST,
  POST_FORM_SUCCESS,
  POST_FORM_ERROR,
  ON_START_DESIGN,
  ON_PAUSE,
  ON_FINFISH_TIMER,
  ON_TICK,
  ON_TICK_PAUSE,
  ON_TICK_FINAL,
  ON_FINAL_FORM,
  ON_FINISH,
  ON_FINIFSH_FORM,
  ON_PREPAUSE,
  ON_PREPAUSE_FINISH,
  POST_FORM_DESIGN_REQUEST,
  POST_FORM_DESIGN_SUCCESS,
  POST_FORM_DESIGN_ERROR,
  STATE_ID
} from "./../reducers/app"

import { PAUSE_DURATION, TWO_HOURS_DURATION } from "./../reducers/app"

// import { 
//   GET_RECORDS_REQUEST,
//   GET_RECORDS_SUCCESS,
//   GET_RECORDS_ERROR
// } from "./../reducers/records"

export const getState = state => state

const delay = ms => new Promise(resolve => setTimeout(resolve, ms))

export function * postFormFlow () {
  while (true) {
    const action = yield take(POST_FORM_REQUEST)
    try {
      const state = yield select(getState)
      const { name, email, portfolio0, portfolio1, portfolio2 } = state.app.form 
      // const payload = yield call(sendPortfolio, { name, email, portfolio0, portfolio1, portfolio2 })
      yield put({ type: POST_FORM_SUCCESS })
      localStorage.setItem(STATE_ID, JSON.stringify({ ...state.app }))
    } catch (error) {
      yield put({ type: POST_FORM_ERROR, error })
    }
  }
}

export function * changeFormFlow () {
  while (true) {
    const action = yield take(ON_CHANGE_FORM)
    try {
      const state = yield select(getState)
      localStorage.setItem(STATE_ID, JSON.stringify(state.app))
    } catch (error) {
    }
  }
}



function* tick() {
  while(true) {
      const state = yield select(getState)
    // if(!state.app.paused){
      yield call(delay, 1000);
      const elasped = new Date((TWO_HOURS_DURATION + (PAUSE_DURATION - state.app.leftPause || 0)) - new Date(new Date().getTime() - state.app.startedAt.getTime()).getTime())
      const offset = elasped.getTimezoneOffset()
      // if(elasped.getTime() + (pause_left)< 0)
      const hours = elasped.getHours() + offset / 60
      yield put({type: ON_TICK, payload: { hours, counter: `${hours}:${fillZero(elasped.getMinutes())}’${fillZero(elasped.getSeconds())}`} });
      if(elasped.getTime() <= 0){
        yield put({type: ON_PREPAUSE, payload: { step: 3, hours, counter: `0:00’00`} })
        break
      }

    // }
    localStorage.setItem(STATE_ID, JSON.stringify({ ...state.app }))
  }
}

function* tickPause() {
  const date = new Date()
  const state = yield select(getState)
  while(true) {
    
      yield call(delay, 1000)
      const leftPause = Math.max(state.app.leftPause - (new Date().getTime() - date.getTime()), 0)
      yield put({type: ON_TICK_PAUSE, payload: { leftPause } })
      if(leftPause <= 0){
        yield put({type: ON_START_DESIGN, payload: { leftPause } })
        break
      }
    const writeState = yield select(getState)
    localStorage.setItem(STATE_ID, JSON.stringify({ ...writeState.app }))
  }
}

export function * startDesignFlow () {
  while (true) {
    yield take(ON_START_DESIGN)
    try {
      const bgSyncTask = yield fork(tick)
      yield take(ON_PAUSE)
      yield cancel(bgSyncTask)
      
    } catch (error) {
    }
  }
}

export function * pauseFlow () {
  while (true) {
    yield take(ON_PAUSE)
    try {
      const bgSyncTask = yield fork(tickPause)
      yield take(ON_START_DESIGN)
      yield cancel(bgSyncTask)
      
    } catch (error) {
    }
  }
}


function* tickFinal() {
  while(true) {
    try {
      yield call(delay, 1000)
      const state = yield select(getState)
      if(state.app.step === 5){
        break
        return
      }

      const elasped = new Date(300000 - new Date(new Date().getTime() - state.app.finalAt.getTime()).getTime())
      const offset = elasped.getTimezoneOffset()
      const hours = elasped.getHours() + offset / 60
      yield put({type: ON_TICK_FINAL, payload: { step: 4, hours, counter: `${hours}:${fillZero(elasped.getMinutes())}’${fillZero(elasped.getSeconds())}`} });
      if(elasped.getTime() <= 0){
        yield put({type: ON_TICK_FINAL, payload: { step: 4, hours, counter: `0:00’00`} })
        yield call(delay, 1000)
        yield put({type: ON_FINISH, payload: { step: 5 } })
        break
      }
      localStorage.setItem(STATE_ID, JSON.stringify({ ...state.app }))
    } catch (error) {
      console.log(error)
    }

  }
}


export function * finalFormFlow () {
  while (true) {
    yield take(ON_FINAL_FORM)
    document.querySelector('body').style.minHeight = '1920px'
    try {
      const bgSyncTask = yield fork(tickFinal)
      
      yield take(ON_FINIFSH_FORM)
      yield cancel(bgSyncTask)
      const state = yield select(getState)
      localStorage.setItem(STATE_ID, JSON.stringify({ ...state.app }))
    } catch (error) {
    }
  }
}

export function * prepauseFlow () {
  while (true) {
    yield take(ON_PREPAUSE)
    const state = yield select(getState)
    localStorage.setItem(STATE_ID, JSON.stringify(state.app))
    try {
      yield call(delay, 5000)
      yield put({type: ON_FINAL_FORM, payload: { step: 4, counter: '0:04’59' } })      
    } catch (error) {
    }
  }
}

export function * postFormDesignFlow () {
  while (true) {
    const action = yield take(POST_FORM_DESIGN_REQUEST)
    try {
      const state = yield select(getState)
      const { name, email, task0, task1, task2 } = state.app.form 
      // const payload = yield call(sendResult, { name, email, task0, task1, task2 })
      yield put({ type: POST_FORM_DESIGN_SUCCESS, payload: { step: 5} })
      localStorage.setItem(STATE_ID, JSON.stringify(state.app))    
    } catch (error) {
      yield put({ type: POST_FORM_DESIGN_ERROR, error })
    }
  }
}

export default function * root () {
  // yield fork(getRecordsFlow)
  yield fork(postFormFlow)
  yield fork(changeFormFlow)
  yield fork(startDesignFlow)
  yield fork(pauseFlow)
  yield fork(finalFormFlow)
 
  yield fork(prepauseFlow)
  
  yield fork(postFormDesignFlow)

 
 
  const state = yield select(getState)
  if(state.app.step === 2){
    yield put({ type: ON_START_DESIGN })
  }
  if(state.app.step === 3){
    yield put({ type: ON_PREPAUSE })
  }
  if(state.app.step === 4){
    yield put({ type: ON_FINAL_FORM })
  }
  
}


// WEBPACK FOOTER //
// ./src/sagas/app.js